import { render, staticRenderFns } from "./PageBlank.vue?vue&type=template&id=5ec260a8&"
import script from "./PageBlank.vue?vue&type=script&lang=js&"
export * from "./PageBlank.vue?vue&type=script&lang=js&"
import style0 from "./PageBlank.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports